const menuToggleBtn = document.querySelector("#menu-toggle");
const menuCloseBtn = document.querySelector("#menu-close-btn");
const bigNav = document.querySelector(".big-nav");

menuToggleBtn?.addEventListener("click", handleToggleClick);
menuCloseBtn?.addEventListener("click", handleToggleClick);

function handleToggleClick(e) {
    e.preventDefault();
    if (bigNav.dataset.active === "true") {
        bigNav.dataset.active = "false";
    } else {
        bigNav.dataset.active = "true";
    }
}